import 'jquery';
import Rails from 'rails-ujs';
Rails.start();
import 'jquery-validation';

require('jquery-ui-dist/jquery-ui');
import 'slick-carousel-browserify';
import './pages/gallery-image-container/gallery-image-container-slider';
import './pages/single-gallery-slider';
